import React, { useState, useEffect, useContext } from 'react'
import VideoPlayer from '../VideoPlayer';
import { DiscussionContainer, Card, TextWrapper, TopLine, SectionText, RowOneContainer, RowTwoContainer, BtnWrap, BtnLink } from './DiscussionElements';
import { AccountContext } from '../Accounts'
import { useNavigate } from 'react-router-dom'

const Discussion = () => {
    const [login, setLogin] = useState(false);
    const { getSession } = useContext(AccountContext);

    const navigate = useNavigate();

    useEffect(() => {
        getSession()
            .then(session => {
                // console.log(session.idToken.payload);
                setLogin(true);
            })
            .catch(err => {
                console.log(err);
                navigate('/signin')
            })
    });

    const file = 'rayms.mp4'

    return (
        login ? (
            <DiscussionContainer>
                <VideoPlayer file={file} />
            </DiscussionContainer >
        ) :
            <></>
    );
};

export default Discussion;

